export { default as StoreProductsPage } from './ui/StoreProductsPage';
